// extracted by mini-css-extract-plugin
export default {"deductionContainer":"deductions_deductionContainer__34335","tabList":"deductions_tabList__sDWiK","tab":"deductions_tab__T0eTx","active":"deductions_active__w25E-"};